<template>
  <a-drawer width="55%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="userId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('师傅提现.用户ID')}}<template slot="title">{{$t('师傅提现.用户ID')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.userId" disabled="true"/>
      </a-form-model-item>

      <a-form-model-item prop="nickName" >
        <span slot="label" >
          <a-tooltip>
            {{$t('师傅提现.师傅信息')}}<template slot="title">{{$t('师傅提现.师傅信息')}}</template>
          </a-tooltip>
        </span>
        <a-input :value="form.nickName + ' / ' + form.mobile" disabled="true"/>
      </a-form-model-item>

      <a-form-model-item prop="money" >
        <span slot="label" >
          <a-tooltip>
            {{$t('师傅提现.提现金额')}}<template slot="title">{{$t('师傅提现.提现金额')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.money" disabled="true"/>
      </a-form-model-item>

      <a-form-model-item prop="serviceChargeNum" >
        <span slot="label" >
          <a-tooltip>
            {{$t('师傅提现.提现手续费')}}<template slot="title">{{$t('师傅提现.提现手续费')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.serviceChargeNum" disabled="true"/>
      </a-form-model-item>

      <a-form-model-item prop="accountNum" >
        <span slot="label" >
          <a-tooltip>
            {{$t('师傅提现.提现账号')}}<template slot="title">{{$t('师傅提现.提现账号')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.accountNum" disabled="true"/>
      </a-form-model-item>

      <a-form-model-item prop="accountName" >
        <span slot="label" >
          <a-tooltip>
            {{$t('师傅提现.提现账号姓名')}}<template slot="title">{{$t('师傅提现.提现账号姓名')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.accountName" disabled="true"/>
      </a-form-model-item>

      <a-form-model-item prop="withdrawScene" >
        <span slot="label" >
          <a-tooltip>
            {{$t('师傅提现.提现场景')}}<template slot="title">{{$t('师傅提现.提现场景')}}</template>
          </a-tooltip>
        </span>
        <a-select v-model="form.withdrawScene" disabled="true">
          <a-select-option :value="1">{{$t('师傅提现.线上自动打款')}}</a-select-option>
          <a-select-option :value="2">{{$t('师傅提现.线下手动打款')}}</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item prop="withdrawType" >
        <span slot="label" >
          <a-tooltip>
            {{$t('师傅提现.提现方式')}}<template slot="title">{{$t('师傅提现.提现方式')}}</template>
          </a-tooltip>
        </span>
        <a-select v-model="form.withdrawType" disabled="true">
          <a-select-option value="1">{{$t('师傅提现.支付宝')}}</a-select-option>
          <a-select-option value="2">{{$t('师傅提现.微信')}}</a-select-option>
          <a-select-option value="3">{{$t('师傅提现.银行卡')}}</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item prop="collectionCode" v-if="form.withdrawScene === 2">
        <span slot="label" >
          <a-tooltip>
            {{$t('师傅提现.用户收款码')}}<template slot="title">{{$t('师傅提现.用户收款码')}}</template>
          </a-tooltip>
        </span>
        <div v-if="form.collectionCode">
          <img :src="form.collectionCode" style="max-width: 200px; max-height: 200px;" />
        </div>
        <span v-else>{{$t('通用.文本.无')}}</span>
      </a-form-model-item>

      <a-form-model-item prop="status" >
        <span slot="label" >
          <a-tooltip>
            {{$t('师傅提现.审核状态')}}<template slot="title">{{$t('师傅提现.审核状态')}}</template>
          </a-tooltip>
        </span>
        <a-select v-model="form.status" allowClear>
          <a-select-option :value="0">{{$t('师傅提现.未审核')}}</a-select-option>
          <a-select-option :value="1">{{$t('师傅提现.审核未通过')}}</a-select-option>
          <a-select-option :value="2">{{$t('师傅提现.审核已通过')}}</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item prop="orderNo" >
        <span slot="label" >
          <a-tooltip>
            {{$t('师傅提现.第三方订单号')}}<template slot="title">{{$t('师傅提现.第三方订单号')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.orderNo" disabled="true"/>
      </a-form-model-item>

      <a-form-model-item prop="failureReason" >
        <span slot="label" >
          <a-tooltip>
            {{$t('师傅提现.失败原因')}}<template slot="title">{{$t('师傅提现.失败原因')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.failureReason" disabled="true"/>
      </a-form-model-item>

      <a-form-model-item prop="auditOpinion" >
        <span slot="label" >
          <a-tooltip>
            {{$t('师傅提现.审核意见')}}<template slot="title">{{$t('师傅提现.审核意见')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.auditOpinion" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('师傅提现.审核意见')" />
      </a-form-model-item>

      <a-form-model-item prop="remark" >
        <span slot="label" >
          <a-tooltip>
            {{$t('师傅提现.备注')}}<template slot="title">{{$t('师傅提现.备注')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" type="textarea" :rows="3" :maxLength="500" :placeholder="$t('通用.输入.请输入')+$t('师傅提现.备注')" />
      </a-form-model-item>

      <a-form-model-item prop="createTime" >
        <span slot="label" >
          <a-tooltip>
            {{$t('师傅提现.创建时间')}}<template slot="title">{{$t('师傅提现.创建时间')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.createTime" disabled="true"/>
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitAudit(2)" v-if="form.status == 0">
            {{$t('师傅提现.审核通过')}}
          </a-button>
          <a-button type="danger" :loading="submitLoading" @click="submitAudit(1)" v-if="form.status == 0">
            {{$t('师傅提现.审核拒绝')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getHomeWorkerWithdraw, updateHomeWorkerWithdraw } from '@/api/homeworker/withdraw'

export default {
  name: 'CreateForm',
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        userId: null,
        nickName: null,
        mobile: null,
        money: null,
        serviceChargeNum: null,
        status: 0,
        accountNum: null,
        accountName: null,
        withdrawType: null,
        withdrawScene: null,
        collectionCode: null,
        orderNo: null,
        failureReason: null,
        auditOpinion: null,
        remark: null,
        createTime: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  created () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        nickName: null,
        mobile: null,
        money: null,
        serviceChargeNum: null,
        status: 0,
        accountNum: null,
        accountName: null,
        withdrawType: null,
        withdrawScene: null,
        collectionCode: null,
        orderNo: null,
        failureReason: null,
        auditOpinion: null,
        remark: null,
        createTime: null
      }
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getHomeWorkerWithdraw({ id: id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('师傅提现.审核')
      })
    },
    /** 审核确认：auditStatus 1-审核拒绝 2-审核通过 */
    submitAudit: function (auditStatus) {
      // 审核拒绝时，必须填写审核意见
      if (auditStatus === 1 && !this.form.auditOpinion) {
        this.$message.warning(this.$t('师傅提现.请填写审核意见'))
        return
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          this.form.status = auditStatus
          updateHomeWorkerWithdraw(this.form).then(response => {
            this.$message.success(this.$t('通用.文本.修改成功'), 3)
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
